// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linesHeaderStyles } from "@ces/App/Components/Cart/LinesHeader";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, getSystemColor, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

linesHeaderStyles.wrapper = {
    css: css`
        display: grid;
        ${({ includeActions }: any) =>
            includeActions
                ? "grid-template-columns: 99px minmax(0, 66px) minmax(45px, 1fr) minmax(0, 165px) minmax(0, 123px) minmax(0, 149px) minmax(0,24px);"
                : "grid-template-columns: 99px minmax(0, 66px) minmax(45px, 1fr) minmax(0, 165px) minmax(0, 123px) minmax(0, 149px);"};

        grid-column-gap: 12px;
        grid-auto-flow: column;
        padding: 0 12px;
        color: ${color("text")};
        font-size: 12px;
        line-height: 14px;
        font-weight: ${fontConfig.weight.bold};
        width: 100%;
        background: ${color("common.ui11")};
        border: 1px solid ${color("common.border")};
        border-radius: 2px;
        @media print {
            color: ${getSystemColor("text")};
            background: ${getSystemColor("common.ui11")};
        }
    `,
};
linesHeaderStyles.itemDescription = {
    css: css`
        grid-column: 1 / 4;
        padding: 8px 12px 8px 0px;
        border-right: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            border: none;
            grid-column: 1 / 6;
        }
    `,
};

linesHeaderStyles.priceUnit = {
    css: css`
        grid-column: 4 / 5;
        padding: 8px 12px 8px 0px;
        border-right: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
linesHeaderStyles.qty = {
    css: css`
        grid-column: 5 / 6;
        padding: 8px 12px 8px 0px;
        border-right: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.total = {
    css: css`
        grid-column: 6 / 7;
        padding: 8px 12px 8px 0px;
        ${({ includeActions }: any) =>
            includeActions
                ? css`
                      border-right: 1px solid ${color("common.border")};
                  `
                : ""}
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

linesHeaderStyles.mdScreenBorder = {
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: block;
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};
